module.exports = __webpack_public_path__ + "static/media/jill2.0a834193.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jill2.gif
// module id = 156
// module chunks = 0